export const EDIT_MODE = 'edit';
export const PAIR_SORTING_MODE = 'pair-sorting';
export const VIEW_MODE = 'view';
